<template>
	<v-hover
		:value="value"
		:disabled="disabled"
		:open-delay="openDelay"
		v-bind="$attrs"
		v-on="$listeners"
		v-slot:default="defaultSlotProps"
	>
		<slot v-bind="defaultSlotProps" />
	</v-hover>
</template>

<script>
export default {
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		openDelay: {
			type: [Number, String],
			default: 0
		}
	}
};
</script>